import Sidebar from './components/Sidebar/Sidebar';
import Wrapper from './components/Wrapper/Wrapper';

function App() {
  return (
    <div className="App">
      <Sidebar />
      <Wrapper />
    </div>
  );
}

export default App;
